module.exports = __webpack_public_path__ + "static/media/sunglass1.289c65e2.jpg";